// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1n-r1","col":"styles_col__3VpLz"};